import { createContext } from "react";
import admin, { Admin } from "./admin";

const AdminContext = createContext({
    ...admin,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    login: (_admin: Admin) => {},
})

export default AdminContext;